import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectRecipients = (state: RootState) =>
  sortBy(state.recipients.recipients, 'name');

export const selectRecipientErrors = (state: RootState) =>
  state.recipients.errors;
